import React from 'react';
import './CustomerServices.scss';
import { Button } from '@orderly/morrisons-component-library';

const DHL_PHONE_NUMBER = '0330 678 1235';
const DHL_EMAIL_ADDRESS = 'MWhCustomerServices@dhl.com';
const WHOLESALE_SUPPORT_ADDRESS = 'Wholesale.support@morrisonsplc.co.uk';
const WHOLESALE_FINANCE_ADDRESS = 'wholesale.finance@morrisonsplc.co.uk';
const WHOLESALE_HELPDESK_PHONE_NUMBER = '020 3991 8288';
const WHOLESALE_HELPDESK_ADDRESS = 'wholesalehelpdesk@morrisonsplc.co.uk';

const CustomerServices = () => {
  return (
    <div className="customer-services-wrapper">
        <h1>DHL Customer Services</h1>
        <div className="customer-services-content">
            <p className="semibold">At Morrisons, delivering excellent customer service is our number one priority.</p>
            <p className="semibold">If you have a delivery related query, our DHL customer services team is here to help,</p>
            <p className="semibold">simply get in touch via the phone number or email below!</p>
            <br />
            <p className="faded">Here to help!</p>
            <p className="service-schedule">07:00 - 18:00 - 7 days</p>
            <p className="faded">If calling outside these hours, leave a voicemail and <br />
                DHL will get back as soon as possible.
            </p>
        </div>
        <div className="customer-services-phone">
            <a href={`tel:${DHL_PHONE_NUMBER}`}>
                {DHL_PHONE_NUMBER}
            </a>
        </div>
        <div className="customer-services-email">
            <a className="email-link-bold" href={`mailto:${DHL_EMAIL_ADDRESS}`}>
                {DHL_EMAIL_ADDRESS}
            </a>
        </div>
        <hr />
        <div className="customer-services-stock-claims">
            <h1>Stock Claims</h1>
            <h3>Stock Claims Process</h3>
            <p className="faded">Claims should be made online on the portal within 24 hours of delivery.
                DHL will review all claims submitted.
            </p>
        </div>
        <hr />
        <div className="customer-services-finance">
            <h1>Finance</h1>
            <p>The finance team are available to handle any finance or invoice queries by email.</p>
            <p>
                Contact:&nbsp;
                <a className="email-link-bold" href={`mailto:${WHOLESALE_FINANCE_ADDRESS}`}>
                    {WHOLESALE_FINANCE_ADDRESS}
                </a>
            </p>
        </div>
        <hr />
        <div className="customer-services-franchise-helpdesk">
            <h1>Morrisons Daily Franchise Helpdesk</h1>
            <p>The helpdesk is available 9am-5pm Monday to Friday for all general queries.
                You are able to contact your helpdesk by phone or email.
            </p>
            <p>
                Contact:&nbsp;
                <a href={`tel:${WHOLESALE_HELPDESK_PHONE_NUMBER}`}>
                    {WHOLESALE_HELPDESK_PHONE_NUMBER}
                </a>
            </p>
            <p>
                <a className="email-link-bold" href={`mailto:${WHOLESALE_HELPDESK_ADDRESS}`}>
                    {WHOLESALE_HELPDESK_ADDRESS}
                </a>
            </p>
        </div>
        <hr />
        <div className="customer-services-greencore">
            <h1>Greencore</h1>
            <p>For any changes to your Greencore order including increases, decreases or <br />
                special events please contact Greencore on the phone number below
            </p>
            <ul>
                <li>0333 136 3333</li>
                <li>Monday to Friday 7am - 5pm</li>
                <li>Saturday and Bank Holidays 8am - 1:30pm</li>
            </ul>
        </div>
        <hr />
        <div className="customer-services-it-support">
            <h1>Morrisons IT Support</h1>
            <div>
                For any issues with Morrisons technology including the Wholesale Portal and Wholesale App, please get <br/>
                in touch via the email address below. For all other technology related issues please contact your IT <br />
                provider.
            </div>
            <a className="email-link-bold" href={`mailto:${WHOLESALE_SUPPORT_ADDRESS}`}>
              {WHOLESALE_SUPPORT_ADDRESS}
            </a>
            <a href={`mailto:${WHOLESALE_SUPPORT_ADDRESS}`}>
              <Button className="btn-success" text="Send an email" type="button" />
            </a>
            <div>
                We aim to respond to all queries within 24 hours
            </div>
        </div>
        <hr />
        <div className="customer-services-it-queries">
            <h2>For all other queries please contact your Morrisons <br/> account management team</h2>
        </div>
        <hr />
        <div className="customer-services-weekend-cover">
            <h1>Weekend Cover</h1>
            <div>In the event of a business critical emergency over the weekend, please refer to your <br />
             weekly bulletin for Morrisons on call details and follow your normal escalation process
            </div>
        </div>
    </div>
  );
};

export default CustomerServices;
